import { useState, type ChangeEvent } from "react";

import style from "./style.module.scss";
import { Button } from "../../../ui";
import type { Product } from "../../../data/api/products";

interface PromoCodeFormProps {
  product: Product;
  onApply: (code: string) => void;
}

function PromoCodeForm({ product, onApply }: PromoCodeFormProps) {
  const [code, setCode] = useState(product.promoCode || "");
  const [isEditing, setIsEditing] = useState(!product.promoCode);

  const onChangeCode = (event: ChangeEvent<HTMLInputElement>) => {
    setCode(event.target.value);
  };

  const startEditing = () => {
    setIsEditing(true);
  };

  const applyCode = () => {
    onApply(code);
    setIsEditing(false);
  };

  if (!isEditing) {
    return (
      <button className={style.editLink} onClick={startEditing}>
        Modifier le code promo
      </button>
    );
  }

  return (
    <div className={style.container}>
      <label>
        <h4 className={style.title}>Code Promo</h4>
        <input className={style.input} type="text" value={code} onChange={onChangeCode} />
      </label>
      <Button className={style.button} isPrimary onClick={applyCode}>
        Appliquer
      </Button>
    </div>
  );
}

export default PromoCodeForm;
